module.exports = __webpack_public_path__ + "static/media/login.c733388.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/login.mp4
// module id = R0mb
// module chunks = 0